export default __webpack_public_path__ + "static/media/Rockrooster-Cover-400x482.8ee7094d.jpg";